// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G1kNg","clinicsSelect":"styles_clinicsSelect__3aI1H"};